<div class="view-container px-spacing-3xl">
  <div 
    class="grid list-container grid-nogutter p-spacing-md" 
    style="background-color: #f8f9fb"
    [ngStyle]="{minWidth: selectedView() == 1 ? '1500px' : 'unset'}">
    <div [ngClass]="{ 'col-12': selectedView() == 1, 'col-6 list-col': selectedView() == 2 }">
      <section class="list">
        <app-ride-list-item [view]="selectedView() == 1 ? 'rides-list' : 'rides-list-map-view'"
          (ridesChange)="onRidesChanged($event)"> </app-ride-list-item>
      </section>
    </div>

    <div class="col-6 map-col" [ngClass]="{'hidden': selectedView() != 2}">
      <div #mapContainer class="map-container main-drivers-map h-full border-round-bottom-lg overflow-hidden">
        <div #mapDiv class="custom-goole-map" style="width: 100%; height: 100%;"></div>

        <div class="map-legend-container">
          <div
            class="map-legend flex flex-column py-spacing-md px-spacing-xl text-inverse-bg gap-spacing-xs border-round-lg border-1 border-brand-lighter-border">
            <div class="item flex gap-spacing-md">
              <span class="dot success"></span>
              <span class="body-medium-regular text-primary-color">Ride Assigned Driver</span>
            </div>
            <div class="item flex gap-spacing-md">
              <span class="dot light-warning"></span>
              <span class="body-medium-regular text-primary-color">Offered Ride</span>
            </div>
            <div class="item flex gap-spacing-md">
              <span class="dot warning"></span>
              <span class="body-medium-regular text-primary-color">Sub Assigned Driver</span>
            </div>
            <div class="item flex gap-spacing-md">
              <span class="dot danger"></span>
              <span class="body-medium-regular text-primary-color">In Progress / Accepted Ride</span>
            </div>
          </div>
        </div>
        

      </div>

    </div>
  </div>
</div>